import React, { useEffect, useState } from "react";
import Search from "../Search/Search";
import settingIcon from "../../img/settingIcon.svg";
import addPlusIcon from "../../img/addPlusIcon.svg";
import moreBtnTableIcon from "../../img/moreButtonTable.svg";
import preparedIcon from "../../img/preparedTableIocn.svg";
import unPreparedIcon from "../../img/unPreparedTableIocn.svg";
import CargoCaseDocSetCreateModal from "../CargoCaseDocSetCreateModal/CargoCaseDocSetCreateModal";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";
import CargoCaseDocSetLoadingOrder from "../CargoCaseDocSetLoadingOrder/CargoCaseDocSetLoadingOrder";
import CargoCaseDocSetBol from "../CargoCaseDocSetBol/CargoCaseDocSetBol";
import CargoCaseDocSetMan from "../CargoCaseDocSetMan/CargoCaseDocSetMan";
import CargoCaseDocSetMenu from "../CargoCaseDocSetMenu/CargoCaseDocSetMenu";
import TableRowMenu from "../ReusedComponents/TableRowMenu/TableRowMenu";
import { onHandleShowTableMenu } from "../../utils/OnHandleShowTableMenu/OnHandleShowTableMenu";
import CargoCaseCancelCreateModal from "../CargoCaseCancelCreateModal/CargoCaseCancelCreateModal";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import { NotificationButton } from "./NotificationButton";
import rowDownTable from "../../img/rowDownTableIcon.svg";

const CargoCase = (props) => {

  const { getListCargoCase, setGetListCargoCase } = props;

  const [filter, setFilter] = useState("");

  const [errorMessage, setErrorMessage] = useState("");
  const [activeListOrder, setActiveListOrder] = useState(null);
  const [activeTableRowMenu, setActiveTableRowMenu] = useState(null);
  const { auth, stateReducer, setNameDocHeader, cleanIdCreateDoc } = useAuth();
  const [cargoCaseDocument, setCargoCaseDocument] = useState([]);
  const [isNewDocCargoCase, setIsNewDocCargoCase] = useState(false);
  const [activeCancelModal, setActiveCancelModal] = useState(false);
  const [activeCargoCaseTable, setActiveCargoCaseTable] = useState(true);
  const [activeNoLoadingOrder, setActiveNoLoadingOrder] = useState(false);
  const [activeDocSetType, setActiveDocSetType] = useState('Loading order');
  const [isHideCreateSettingsBtn, setHideCreateSettingsBtn] = useState(true);
  const [activeDocumentNotFound, setActiveDocumentNotFound] = useState(false);
  const [arrayCheckCreateCargoCase, setArrayCheckCreateCargoCase] = useState([]);
  const [activeCreateCargoCaseModal, setActiveCreateCargoCaseModal] =useState(false);
  const [sortType, setSortType] = useState("down");

  const getContainerClass = document.querySelector('.cargo-case__container');
  const optionFilterCargoCaseConsignee = getListCargoCase ? getListCargoCase.map(el => el?.consignee) : [];
  const optionFilterCargoCaseVessel = getListCargoCase ? getListCargoCase.map(el => el?.vessel) : [];
  const optionFilterCargoCaseShipper = getListCargoCase ? getListCargoCase.map(el => el?.shipper) : [];
  const optionFilterCargoCaseCarrier = getListCargoCase ? getListCargoCase.map(el => el?.shipowner).filter(el => el !== undefined) : [];
  const optionFilterCargoCaseDate = getListCargoCase ? getListCargoCase.map(el => el?.dateOfCreation) : [];

  useEffect(() => {
    let isMounted = true;

    if (getListCargoCase.length > 0) {
        isMounted && setActiveCargoCaseTable(true);
        isMounted && setActiveDocumentNotFound(false);
        isMounted && setNameDocHeader("");
        isMounted && setActiveDocSetType('Loading order');
        isMounted && setIsNewDocCargoCase(false);
        isMounted && setCargoCaseDocument([]);
        isMounted && setArrayCheckCreateCargoCase([]);
        isMounted && setActiveListOrder(null);
        isMounted && setHideCreateSettingsBtn(true);
    } else {
        isMounted && setActiveDocumentNotFound(true);
        isMounted && setActiveCargoCaseTable(false);
        isMounted && setNameDocHeader("");
        isMounted && setActiveDocSetType('Loading order');
        isMounted && setIsNewDocCargoCase(false);
        isMounted && setCargoCaseDocument([]);
        isMounted && setArrayCheckCreateCargoCase([]);
        isMounted && setActiveListOrder(null);
    }

    return () => {
      isMounted = false;
    };
  }, [getListCargoCase.length, stateReducer.toggleBackPage]);

  function handleNewDocCargoCaseModal(
    checkLoadOrder,
    checkBol,
    checkMan,
    nameDoc
  ) {
    if (nameDoc === "") {
      setErrorMessage("You must enter a title for the document.");
    } else {
      const arrCheckBoxes = [
        { checkActive: checkLoadOrder, nameTypeDoc: 'Loading order' },
        { checkActive: checkBol, nameTypeDoc: "BOL" },
        { checkActive: checkMan, nameTypeDoc: "MAN" },
      ];
      const typeDoc = arrCheckBoxes.filter((el) => el.checkActive === true);
      const newDoc = {
        number: nameDoc,
        dateOfCreation: "",
        bols: [],
        manifests: [],
        orders: []
      };
      setIsNewDocCargoCase(true);
      setNameDocHeader(nameDoc);
      setArrayCheckCreateCargoCase(typeDoc);
      setErrorMessage("");
      setActiveNoLoadingOrder(checkLoadOrder);
      setActiveCreateCargoCaseModal(false);
      setActiveDocumentNotFound(false);
      setActiveCargoCaseTable(false);
      setCargoCaseDocument([newDoc]);
      setHideCreateSettingsBtn(false);
    }
  }

  function closeModal() {
    setActiveCreateCargoCaseModal(false);
  }

  function closeCancelModal() {
    setActiveCancelModal(false);
  }

  function onShowDocSetMenu(index, nameItemMenu) {
    if (activeListOrder !== index) {
      setActiveListOrder(index);
      setActiveDocSetType(nameItemMenu);
    } else {
      setActiveListOrder(null);
    }
  }

  function onShowCreateCargoCaseModal() {
    setActiveCreateCargoCaseModal(true);
  }

  function onSelectedCargoCase(id) {
    const selectCargoCase = getListCargoCase.find((el) => el.id === id);
    setNameDocHeader(selectCargoCase?.number);
    setActiveDocumentNotFound(false);
    setActiveCargoCaseTable(false);
    setActiveNoLoadingOrder(true);
    setCargoCaseDocument([selectCargoCase]);
    setHideCreateSettingsBtn(false);
  }

  useEffect(() => {
    if (stateReducer.idCreateDoc !== null) {
      const selectCargoCase = getListCargoCase.find(
        (el) => el?.id === stateReducer.idCreateDoc
      );
      setNameDocHeader(selectCargoCase?.number);
      setCargoCaseDocument([selectCargoCase]);
      cleanIdCreateDoc();
      setActiveDocumentNotFound(false);
      setActiveCargoCaseTable(false);
      setActiveNoLoadingOrder(true);
    }
  }, [getListCargoCase]);

  const clickSortCargoDate = (sortType) => {
    if (sortType === "down") {
      setSortType("up");
      getListCargoCase.sort((a, b) => (a.orderDate > b.orderDate ? 1 : -1));
    } else if (sortType === "up") {
      setSortType("down");
      getListCargoCase.sort((a, b) => (b.orderDate > a.orderDate ? 1 : -1));
    }
  };

  return (
    <div className="cargo-case__container">
      {isHideCreateSettingsBtn && (
        <div className="cargo-case-search-create-button">
          <Search value={filter} 
                  setValue={setFilter}
                  getListCargoCase={getListCargoCase}
                  setGetListCargoCase={setGetListCargoCase} 
                  getContainerClass={getContainerClass}
                  optionFilterCargoCaseConsignee={optionFilterCargoCaseConsignee}
                  optionFilterCargoCaseVessel={optionFilterCargoCaseVessel}
                  optionFilterCargoCaseShipper={optionFilterCargoCaseShipper}
                  optionFilterCargoCaseCarrier={optionFilterCargoCaseCarrier}
                  optionFilterCargoCaseDate={optionFilterCargoCaseDate}
          />
          <div
            className={
              activeCargoCaseTable
                ? "cargo-case-search-create-button__buttons"
                : "cargo-case-search-create-button__buttons hide"
            }
          >
            {/* <div className="cargo-case-search-create-button__button-icon-setting">
              <img
                className="cargo-case-search-create-button__icon-settings"
                src={settingIcon}
                alt={"иконка настройки"}
              />
              <p>Settings</p>
            </div> */}
            <NotificationButton />
            {auth?.roles[0] === "CAPTAIN" || auth?.roles[0] === "FORWARDER" ? (
              <div
                onClick={() => setActiveCreateCargoCaseModal(true)}
                className="cargo-case-search-create-button__button-icon-add-cargo-case"
              >
                <img
                  className="cargo-case-search-create-button__icon-add-plus"
                  src={addPlusIcon}
                  alt={"иконка плюс"}
                />
                <p>Create cargo case</p>
              </div>
            ) : null}
          </div>
        </div>
      )}
      <div className="cargo-case-main-block">
        {activeCargoCaseTable ? (
          <div className="cargo-case-table">
            <div className="cargo-case-table-header">
              <p>Number</p>
              <p>Vessel</p>
              <p>Carrier</p>
              <p>Consignee</p>
              <p>Shipper</p>
              <p onClick={() => clickSortCargoDate(sortType)} className="cargo-case-table-header--cursor">Date
                <img
                    className={
                      sortType === "up"
                          ? "notification-table-table-row__row-sort-up"
                          : "notification-table-table-row__row-sort-down"
                    }
                    src={rowDownTable}
                    alt={"icon"}
                /></p>
              <p>Status</p>
            </div>
            {getListCargoCase
              .filter((el) => el?.number?.includes(filter))
              .map((el) => {
                return (
                  <div
                    onClick={() => onSelectedCargoCase(el?.id)}
                    key={el?.id}
                    className="cargo-case-table-row"
                  >
                    <p>{el?.number}</p>
                    <p>{el?.vesselName}</p>
                    <p>{el?.shipownerName}</p>
                    <p>{el?.consignee}</p>
                    <p>{el?.shipperName}</p>
                    <p>{el?.dateOfCreation}</p>
                    <div className="cargo-case-table-row-status">
                      <img
                        className="cargo-case-table-row-status__icon-prepared"
                        src={
                          el?.status === "PREPARED"
                            ? preparedIcon
                            : unPreparedIcon
                        }
                        alt={"иконка подготовлен"}
                      />
                      {/* <img onClick={(e) => onHandleShowTableMenu(el?.id, activeTableRowMenu, setActiveTableRowMenu, e)} className="cargo-case-table-row-status__icon-more-btn" src={moreBtnTableIcon} alt={'иконка показать больше'}/>
                                            <TableRowMenu
                                                index={el.id}
                                                activeTableRowMenu={activeTableRowMenu}
                                                handelTableMenu={onSelectedCargoCase}
                                            /> */}
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="cargo-case-create-document">
            {activeDocumentNotFound ? (
              <>
                <CreateNewDocuments
                  handeClickCreateNew={onShowCreateCargoCaseModal}
                  hiddenUploadBtn={false}
                  activeDocumentNotFound={activeDocumentNotFound}
                />
              </>
            ) : (
              <div className="cargo-case-doc-set-menu">
                <div className="cargo-case-doc-set-menu__list-item">
                  <CargoCaseDocSetMenu
                    onShowDocSetMenu={onShowDocSetMenu}
                    docTypeBol={cargoCaseDocument[0]?.bols}
                    docTypeMan={cargoCaseDocument[0]?.manifests}
                    docTypeOrder={cargoCaseDocument[0]?.number}
                    activeListOrder={activeListOrder}
                    arrayCheckCreateCargoCase={arrayCheckCreateCargoCase}
                    activeDocSetType={activeDocSetType}
                  />
                </div>
                <>
                  {activeDocSetType === 'Loading order' && (
                    <CargoCaseDocSetLoadingOrder
                      cargoCaseDocument={cargoCaseDocument}
                      isNewDocCargoCase={isNewDocCargoCase}
                      setIsNewDocCargoCase={setIsNewDocCargoCase}
                    />
                  )}
                  {activeDocSetType === "BOL" && (
                    <CargoCaseDocSetBol
                      activeNoLoadingOrder={activeNoLoadingOrder}
                      cargoCaseDocument={cargoCaseDocument}
                      isNewDocCargoCase={isNewDocCargoCase}
                    />
                  )}
                  {activeDocSetType === "MAN" && (
                    <CargoCaseDocSetMan
                      activeNoLoadingOrder={activeNoLoadingOrder}
                      cargoCaseDocument={cargoCaseDocument}
                      isNewDocCargoCase={isNewDocCargoCase}
                    />
                  )}
                </>
              </div>
            )}
          </div>
        )}
      </div>
      {activeCreateCargoCaseModal && (
        <CargoCaseDocSetCreateModal
          closeModal={closeModal}
          handleNewDocCargoCaseModal={handleNewDocCargoCaseModal}
          setActiveCreateCargoCaseModal={setActiveCreateCargoCaseModal}
          setActiveCancelModal={setActiveCancelModal}
          errorMessage={errorMessage}
        />
      )}
      {activeCancelModal && (
        <CargoCaseCancelCreateModal closeModal={closeCancelModal} />
      )}
    </div>
  );
};
export default CargoCase;
